import { LoadingStiModule } from "../../../_component/loading-sti/loading-sti.module";
import { SelectDropdownModule } from './../../_component/select-dropdown/select-dropdown.module';
import { StatusModule } from './../../_component/status/status.module';
import { AvatarComponentModule } from './../../_component/avatar/avatar.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RentalDetailsPageRoutingModule } from './rental-details-routing.module';
import { RentalDetailsPage } from './rental-details.page';
import { InputsModule } from 'src/app/_component/inputs/inputs.module';
import { BreadcrumbComponentModule } from './../../_component/breadcrumb/breadcrumb.module';
import { HeaderModule } from "src/app/_component/header/header.module";
import { CardComponentModule } from '../../_component/_structural/card/card.module';
import { TranslateModule } from '@ngx-translate/core';
import { UploadAttachmentModule } from '../../_component/upload-attachment/upload-attachment.module';
import { CommentModule } from '../../_component/comment/comment.module';
import { PipesModule } from 'src/app/_pipes/pipes.module';
import { SharedDirectivesModule } from 'src/app/_directives/shared-directives.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    RentalDetailsPageRoutingModule,
    InputsModule,
    BreadcrumbComponentModule,
    HeaderModule,
    CardComponentModule,
    TranslateModule,
    UploadAttachmentModule,
    CommentModule,
    PipesModule,
    SharedDirectivesModule,
    AvatarComponentModule,
    StatusModule,
    SelectDropdownModule,
    LoadingStiModule
  ],
  declarations: [RentalDetailsPage]
})
export class RentalDetailsPageModule {}
